import getEnvironmentVariable from '@infotech/helper-get-enviroment-variable'

export const REFERENSE_PASSPORT = `${getEnvironmentVariable(
  `REACT_APP_REFERENSE_PASSPORT`,
  process.env.REACT_APP_REFERENSE_PASSPORT,
)}`
export const REFERENSE_DICTIONARY = `${getEnvironmentVariable(
  `REACT_APP_REFERENSE_DICTIONARY`,
  process.env.REACT_APP_REFERENSE_DICTIONARY,
)}`
export const REFERENSE_AUTODATA = `${getEnvironmentVariable(
  `REACT_APP_REFERENSE_AUTODATA`,
  process.env.REACT_APP_REFERENSE_AUTODATA,
)}`
export const COMPLECTATION_SERVICE = `${getEnvironmentVariable(
  `REACT_APP_COMPLECTATION_SERVICE`,
  process.env.REACT_APP_COMPLECTATION_SERVICE,
)}`
export const LOGO_TOP_BAR_NAME = getEnvironmentVariable(
  `REACT_APP_LOGO_TOP_BAR_NAME`,
  process.env.REACT_APP_LOGO_TOP_BAR_NAME,
)
export const CUSTOM_LOGO_URL = getEnvironmentVariable(
  `REACT_APP_CUSTOM_LOGO_URL`,
  process.env.REACT_APP_CUSTOM_LOGO_URL,
)
export const TOIR_INSPECTION_SERVICE = `/toro-inspection-service`
